import React from 'react'

import UnitStatus from '#/components/reportStatus/UnitStatus'

const TypeUnitStatus = ({ value, key }) => {
  if (!value) return <span>-</span>
  return <UnitStatus unit={value} key={key} />
}
export default TypeUnitStatus
